export default __webpack_public_path__ + "static/media/machinerydetailed.82387aaf.jpg";